import { apiGet } from "./requests";
export const getPrinterStatus = () => apiGet("printers/status");
